import { useState, useEffect } from 'react';
import ExchangeMoneyService from './WithdrawRecordService';
import WithdrawRecordService from './WithdrawRecordService';

const useWithdrawRecord = () => {
  const [withdrawRecords, setWithdrawRecord] = useState([])
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const saveWithdrawRecord = async (formData) => {
    let result = true
    setIsLoading(true);
    try {
        if (formData?.id) {
          await WithdrawRecordService.updateWithdrawRecord(formData.id, formData);
        } else {
          await WithdrawRecordService.saveWithdrawRecord(formData);
        }
        await getWithdrawRecords()
        result = true
    } catch (err) {
        result = false
        console.log(err.response.data.message || 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result
  };

  const saveWithdrawRecordsBulk = async (withdrawDate, items) => {
    let result = true;
    setIsLoading(true);
    try {
      await WithdrawRecordService.saveWithdrawRecordsBulk({ withdrawDate, items });
      await getWithdrawRecords();
      result = true;
    } catch (err) {
      result = false;
      console.log(err.response?.data?.message || 'An error occurred.');
    } finally {
      setIsLoading(false);
    }
    return result;
  };

  const getWithdrawRecords = async () => {
    setIsLoading(true);
    try {
      const response = await WithdrawRecordService.getWithdrawRecords();
      setWithdrawRecord(response.data);
      setError(null);
    } catch (err) {
      console.log(err)
      setError(err);
    } finally {
        setIsLoading(false);
    }
  };


  return { 
    withdrawRecords,
    saveWithdrawRecord,
    saveWithdrawRecordsBulk,
    getWithdrawRecords
  };
}

export default useWithdrawRecord;
